import React from 'react';
import Grid from 'components/atoms/Grid';
import Field from 'components/molecules/Field';
import Form from 'components/molecules/Form';

function FinishesSection({ finishes, setFinishes, form }) {
  const addCard = () => {
    setFinishes(prev => [
      ...prev,
      {
        image: null,
        name: '',
        description: '',
        characteristicHeading: '',
        characteristicOption: '',
      },
    ]);
  };

  const removeCard = index => {
    setFinishes(prev => prev.filter((_, i) => i !== index));
  };

  const updateImage = (finishIndex, file) => {
    setFinishes(prev => {
      const updated = [...prev];
      updated[finishIndex].image = file;
      return updated;
    });
  };

  const updateName = (finishIndex, name) => {
    setFinishes(prev => {
      const updated = [...prev];
      updated[finishIndex].name = name;
      return updated;
    });
  };

  const updateDescription = (finishIndex, description) => {
    setFinishes(prev => {
      const updated = [...prev];
      updated[finishIndex].description = description;
      return updated;
    });
  };

  const updateCharacteristicHeading = (finishIndex, characteristicHeading) => {
    setFinishes(prev => {
      const updated = [...prev];
      updated[finishIndex].characteristicHeading = characteristicHeading;
      return updated;
    });
    form.setFieldsValue({
      [`finish_characteristicHeading_${finishIndex + 1}`]: characteristicHeading,
    });
  };

  const updateCharacteristicOption = (finishIndex, characteristicOption) => {
    setFinishes(prev => {
      const updated = [...prev];
      updated[finishIndex].characteristicOption = characteristicOption;
      return updated;
    });
  };

  return (
    <div className="finishes-holder">
      <div className="head">
        <span className="label">Finishes</span>
        <button className="add-more" type="button" onClick={addCard}>
          Add Finish <i className="material-icons-outlined">add</i>
        </button>
      </div>
      <Grid xs={1} lg={2} colGap={10} rowGap={20}>
        {finishes?.map((finish, finishIndex) => (
          <div className="card" key={finishIndex}>
            {finishes.length > 1 && (
              <button className="remove-btn" type="button" onClick={() => removeCard(finishIndex)}>
                <i className="material-icons-outlined">close</i>
              </button>
            )}
            <Form.Item
              name={`finish_image_${finishIndex + 1}`}
              type="chooseFile"
              small
              value={finish?.image}
              displayFile={finish?.image?.preview || finish?.image || null}
              onChange={file => updateImage(finishIndex, file)}
              rules={[{ required: false, message: `Select finish image` }]}>
              <Field />
            </Form.Item>
            <Form.Item
              label="Finish Name"
              name={`finish_name_${finishIndex + 1}`}
              type="text"
              sm
              value={finish?.name}
              onChange={e => updateName(finishIndex, e.target.value)}
              rules={[{ required: false, message: 'Enter finish name' }]}>
              <Field />
            </Form.Item>
            <Form.Item
              label="Finish Description"
              name={`finish_description_${finishIndex + 1}`}
              type="textarea"
              sm
              value={finish?.description}
              onChange={e => updateDescription(finishIndex, e.target.value)}
              rules={[{ required: false, message: 'Enter finish description' }]}>
              <Field />
            </Form.Item>
            <Form.Item
              label="Characteristics Heading"
              name={`finish_characteristicHeading_${finishIndex + 1}`}
              type="text"
              sm
              value={finish?.characteristicHeading}
              onChange={e => updateCharacteristicHeading(finishIndex, e.target.value)}
              rules={[{ required: false, message: 'Enter characteristics heading' }]}>
              <Field />
            </Form.Item>
            <Form.Item
              label="Characteristic Options"
              name={`characteristicOption_${finishIndex + 1}`}
              type="text"
              sm
              value={finish?.characteristicOption}
              onChange={e => updateCharacteristicOption(finishIndex, e.target.value)}
              rules={[{ required: false, message: 'Enter best for' }]}>
              <Field />
            </Form.Item>
          </div>
        ))}
      </Grid>
    </div>
  );
}

export default FinishesSection;
